import { environment } from "environments/environment";

/**
 * Created by idea on 20/03/2017.
 */
export class UtilityService {
    constructor() {
    }

    static route(route: string, id?: string): string {
        var link: string = '/home';
        switch (route) {
            case ROUTE_LOGIN:
                link = '/login';
                break;
            case ROUTE_REGISTER:
                link = '/register';
                break;
            default:
                link = '/home';
                break;

        }
        return link;
    }

    static checkMobile() {
        var isMobile = false; //initiate as false
        // device detection
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;

        return isMobile;
    }


    static convertData(data) {
        var da = [];
        for (let key in data) {
            da.push(data[key]);
        }
        return da;
    }

    static getImg(src: string = null, size: string = 'medium', type?: string) {
        var image = 'http://via.placeholder.com/350x150';
        if (src) {
            if (src.match(/^http/)) {
                image = src
            } else {
                image = environment.api_evs+image;
            }
        }
        return image;
    }

    static numberFormat(number, n?: number, s?: string, c?: string) {
        if (!s) {
            s = ',';
        }
        if (!c || s == ',') {
            c = '.';
        } else {
            c = ',';
        }
        if (!n) {
            n = 0;
        }
        var re = '\\d(?=(\\d{' + 3 + '})+' + (n > 0 ? '\\D' : '$') + ')',
            num = parseFloat(number).toFixed(Math.max(0, ~~n));

        return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
    }

    static dateFormat(date) {
        var d = new Date(date);
        var curr_date = d.getDate();
        var curr_month = d.getMonth();
        curr_month++;
        var curr_year = d.getFullYear();
        return (curr_date + "/" + curr_month + "/" + curr_year + " " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds());
    }

    static getFormattedDate(date) {
        var year = date.getFullYear();

        var month = (1 + date.getMonth()).toString();
        month = month.length > 1 ? month : '0' + month;

        var day = date.getDate().toString();
        day = day.length > 1 ? day : '0' + day;

        return year + '-' + month + '-' + day;
    }

    // add by nguyendx 2017/10/16
    static stringDateToSecondInt(mDate: string) {
        var date = new Date(mDate);
        return date.getTime() / 1000;
    }

    static secondToStringDate(mDate) {
        var date = new Date(mDate * 1000);
        var curr_date = date.getDate();
        var curr_month = date.getMonth() + 1; //Months are zero based
        var curr_year = date.getFullYear();
        return curr_date + "-" + curr_month + "-" + curr_year;
    }

    static validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }
    
    static isValidPhoneNumber(phone) {
        return /^(0|84)(9|3|7|8|5)[0-9]{8}$/.test(phone);
    }

    static getClassStatus(status: string): string {
        var classCss: string = 'default';
        switch (status) {
            case "CREATED" || 0:
                classCss = 'info';
                break;
            case "CONFIRMED":
                classCss = 'primary';
                break;
            case "DELIVERY" || 2:
                classCss = 'warning';
                break;
            case "RECEIVED" || 1:
                classCss = 'success';
                break;
            case "REFUNDED":
                classCss = 'dark';
                break;
            case "REJECTED":
            case "CANCELLED" || 4:
                classCss = 'danger';
                break;
            default:
                classCss = 'default';
                break;

        }
        return classCss;
    }

    static redriectNotify(type, id?: any) {
        let link: { url: string, internal: boolean } = { url: '', internal: true };
        switch (type) {
            case 'Customer_Orders':
                link = { url: '/users/order', internal: true };
                if (id) {
                    link = { url: '/users/order-detail?order_id=' + id, internal: true };
                }
                break;
            case 'Collaborator_Balances':
                link = { url: '/income', internal: false };
                break;
            case 'Affiliate_Orders':
                link = { url: '/order/affiliate', internal: false };
                if (id) {
                    link = { url: '/order/affiliate/' + id, internal: false };
                }
                break;
            case 'Shop_Orders':
                link = { url: '/order/shop', internal: false };
                if (id) {
                    link = { url: '/order/detail/' + id, internal: false };
                }
                break;
            case 'Free_Orders':
                link = { url: '/order_free', internal: false };
                break;
            case 'Shop_Balances':
                link = { url: '/stats/order', internal: false };
                break;

        }
        return link;
    }

    static escapeRegExp(strToEscape) {
        // Escape special characters for use in a regular expression
        return strToEscape.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    };
    
    static trimChar(origString, charToTrim) {
        charToTrim = this.escapeRegExp(charToTrim);
        var regEx = new RegExp("^[" + charToTrim + "]+|[" + charToTrim + "]+$", "g");
        return origString.replace(regEx, "");
    };

}

/*
 *  ROUTING MANAGER
 * */
export const ROUTE_LOGIN: string = 'LOGIN';
export const ROUTE_REGISTER: string = 'REGISTER';






// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Utility.service.ts